import React, { useState, useImperativeHandle } from 'react';
import { OrderedListOutlined } from '@ant-design/icons';
import { ReorderableTable } from '../../../../components/reorderableTable/ReorderableTable';
 
const SearchReorder = ( { items, ref } ) => {
    const [ reorderedKeys, setReorderedKeys ] = useState( items.map( i => i.id ) );
    
    useImperativeHandle( ref, () => ( {
        getItems() { 
            return reorderedKeys;
        }
    } ) );

    const handleOnReorder = ( sortedKeys ) => {  
        setReorderedKeys( sortedKeys );
    };

    return (
        <div className="search-reorder">
            <ReorderableTable 
                pagination={ false }
                reorderable={ true }
                dataSource={ items }
                size="small"
                showHeader={ true }
                onReorder= { handleOnReorder }
                columns={ [
                    {
                        dataIndex: 'sortOrder',
                        key: 'sortOrder', 
                        title: 'Sort Order', 
                        render: ( sortOrder, object, index ) => 
                            <div className="reorder-row">
                                <OrderedListOutlined />    
                                <span style={ { marginLeft: '10px' } }>{ index + 1 }</span>
                            </div>
                    },
                    {
                        dataIndex: 'name',
                        key: 'name', 
                        title: 'Name',
                        render: ( name ) => <span>{ name }</span>     
                    }
                ] }                        
            />  
        </div>
    );
};

export default  SearchReorder;
